import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Tabs, MobileCampusProfileTabShifts, MobileCampusProfileTabServices, MobileCampusProfileTabInformation, MobileCampusProfileTabChildren, MobileContainerAnimation, SwitchStatus } from "../../../../";
import { Grid, makeStyles } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%"
    },
    tab: {
      width: "100%",
      position: "fixed",
      background: theme.palette.background.paper,
      zIndex: "10"
    },
    contentWPX: {
      padding: "48px 0 12px 0"
    },
    content: {
      padding: "48px 12px 12px 12px"
    }
  };
});

var MobileCampusProfile = function MobileCampusProfile(props) {
  var classes = useStyles();
  var defaultTabs = {
    coordinator: [{
      value: "shifts",
      label: "Shifts"
    }, {
      value: "services",
      label: "Services"
    }, {
      value: "information",
      label: "My info"
    }],
    trainer: [{
      value: "shifts",
      label: "Shifts"
    }, {
      value: "services",
      label: "Services"
    }, {
      value: "information",
      label: "My info"
    }],
    parent: [{
      value: "information",
      label: "My info"
    }, {
      value: "children",
      label: "My children"
    }]
  };

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    props && props.translation && props.translation.tabs ? props.translation.tabs[0].value ? setValue(props.translation.tabs[0].value) : props.role ? setValue(defaultTabs[props.role][0].value) : setValue("information") : setValue("information");
  }, [props.translation, props.role]); // Tabs

  var handleTabs = function handleTabs(event, newValue) {
    setValue(newValue);
  };

  var createContentTab = function createContentTab() {
    switch (value) {
      case "shifts":
        return /*#__PURE__*/React.createElement(SwitchStatus, {
          status: props.tabs.shifts.status,
          action_download: function action_download() {
            props.handleDownloadTab(value);
            return null;
          },
          success: function success() {
            return /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.contentWPX
            }, /*#__PURE__*/React.createElement(MobileCampusProfileTabShifts, {
              data: props.tabs.shifts.data || null,
              role: props.role,
              translation: props.translation ? props.translation.shifts : null
            }));
          }
        });

      case "services":
        return /*#__PURE__*/React.createElement(SwitchStatus, {
          status: props.tabs.services.status,
          action_download: function action_download() {
            props.handleDownloadTab(value);
            return null;
          },
          success: function success() {
            return /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.content
            }, /*#__PURE__*/React.createElement(MobileCampusProfileTabServices, {
              data: props.tabs.services.data || null,
              role: props.role,
              translation: props.translation ? props.translation.services : null
            }));
          }
        });

      case "information":
        return /*#__PURE__*/React.createElement(SwitchStatus, {
          status: props.tabs.information.status,
          action_download: function action_download() {
            props.handleDownloadTab(value);
            return null;
          },
          success: function success() {
            return /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.content
            }, /*#__PURE__*/React.createElement(MobileCampusProfileTabInformation, {
              data: props.tabs.information.data || null,
              role: props.role,
              translation: props.translation ? props.translation.information : null
            }));
          }
        });

      case "children":
        return /*#__PURE__*/React.createElement(SwitchStatus, {
          status: props.tabs.children.status,
          action_download: function action_download() {
            props.handleDownloadTab(value);
            return null;
          },
          success: function success() {
            return /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.content
            }, /*#__PURE__*/React.createElement(MobileCampusProfileTabChildren, {
              data: props.tabs.children.data || null,
              role: props.role,
              translation: props.translation ? props.translation.children : null
            }));
          }
        });

      default:
        break;
    }
  };

  return /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classes: classes.root
  }, props.routerState || null), /*#__PURE__*/React.createElement("div", {
    className: classes.tab
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: value,
    onChange: handleTabs,
    variant: "fullWidth",
    indicatorColor: "primary",
    textColor: "primary",
    contentTabs: props.translation && props.translation.tabs ? props.translation.tabs : props.role ? defaultTabs[props.role] : []
  })), createContentTab());
};

export { MobileCampusProfile };